import Checked from "../vectors/Checked";
import Unchecked from "../vectors/Unchecked";

export default function Checkbox({className ='', color, inputClassName ='', id = '', checked, label, onChange, tooltip = null}) {

    const primaryClasses = 'text-primary-blue'
    const secondaryClasses = 'text-mint-green'

    const getColorClasses = () => {
        if (!checked) {
            return 'text-[#0000008a]'
        }

        switch (color) {
            case 'primary':
                return primaryClasses
            case 'secondary':
                return secondaryClasses
            default:
                return ''
        }
    }

    return (
        <div className={'cursor-pointer inline-flex items-center -ml-[11px] mr-4 align-middle no-highlights'}>
            <span
                className={` grow-0 shrink-0 flex-auto p-[9px] overflow-visible text-2xl text-center transition-colors rounded-[50%] border-0 cursor-pointer m-0 inline-flex outline-0 relative items-center select-none align-middle justify-center no-underline bg-transparent appearance-none no-highlights ${className} ${getColorClasses()}`}
                aria-disabled="false"
            >
                <span className={'w-full flex'}>
                    <input
                        onChange={onChange}
                        className={`${inputClassName} top-0 left-0 w-full h-full m-0 opacity-0 p-0 z-1 absolute cursor-pointer`}
                        id={id}
                        data-testid={id}
                        type="checkbox"
                        data-indeterminate="false"
                        value=""
                        checked={checked}
                    />
                    {checked ? <Checked /> : <Unchecked />}
                </span>
                <span className={'top-0 left-0 right-0 bottom-0 z-0 overflow-hidden absolute border-inherit pointer-events-none'}></span>
            </span>
            <span className={'text-[14px] font-normal leading-normal m-0'}>
                <span onClick={onChange}>{label}</span>
                {tooltip && <span className={'inline-flex relative'}>{tooltip}</span>}
            </span>

        </div>
    )
}